import { Component, OnInit, ViewChild } from '@angular/core';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { CpmService } from 'app/service/cpm.service';
import { environment } from '../../../environments/environment';
import { ExportExcelService } from 'app/service/export-excel.service';
import { AseanExchangesComponent } from '../asean-exchanges/asean-exchanges.component';
import { IpoExchangeIn5YearComponent } from '../ipo-exchange-in-5-year/ipo-exchange-in-5-year.component';
import { ExportPPTService } from '../../service/export-ppt.service';
@Component({
  selector: 'app-initial-public-offering',
  templateUrl: './initial-public-offering.component.html',
  styleUrls: ['./initial-public-offering.component.scss']
})
export class InitialPublicOfferingComponent implements OnInit {
  loadGraphFirstTime = true;
  @ViewChild(AseanExchangesComponent) aseanExchanges: AseanExchangesComponent;
  @ViewChild(IpoExchangeIn5YearComponent) ipoExchanges5Year: IpoExchangeIn5YearComponent;
  date
  constructor(
    private router: Router,
    private cpmService: CpmService,
    private excelService: ExportExcelService,
    private pptService: ExportPPTService,
    private datePipe: DatePipe
  ) { }

  initialChart() {
    if (this.loadGraphFirstTime) {
      this.ipoExchanges5Year.markChartCapraised();
      this.date = this.datePipe.transform(this.aseanExchanges.ipoAsofdate, 'd MMM yyyy')
    }
    this.loadGraphFirstTime = false;
  }
  ngOnInit() {
  }

  exportFunctionsIn5Year() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailIn5Year(
        this.cpmService,
        this.ipoExchanges5Year.currentItem
      )
    );

    arrayOfFunctions.set(
      'print',
      this.exportPrintIn5Year(
        this.ipoExchanges5Year.currentItem
      )
    );

    arrayOfFunctions.set(
      'pdf',
      this.exportPdfIn5Year(
        this.ipoExchanges5Year.currentItem
      )
    );

    arrayOfFunctions.set(
      'excel',
      this.exportExcelIn5Year(
        this.excelService,
        this.ipoExchanges5Year.currentItem,
        this.ipoExchanges5Year.dataProviderForIpoCap,
        this.ipoExchanges5Year.ipoHeader,
      )
    );

    arrayOfFunctions.set(
      'ppt',
      this.exportPptIn5Year(
        this.pptService,
        this.ipoExchanges5Year.dataProviderForIpoCap,
        this.ipoExchanges5Year.ipoHeader,
        this.ipoExchanges5Year.textMark
      )
    )
    return arrayOfFunctions;
  }

  exportEmailIn5Year(service, currentItem) {
    return function mailIn5Year() {
      service.saveipoExchangeIn5Year(currentItem).then(filename => {
        const subject = 'Ipo-Exchange-In-5-Year';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  }

  exportPrintIn5Year = function (currentItem) {
    return function in5yearPrint() {
      const popupWin = window.open(
        `/#/ipoExchangeIn5Year/${currentItem}`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };

  exportPdfIn5Year = function (currentItem) {
    const service = this.cpmService;
    return function in5yearPdf() {
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/ipoExchangeIn5Year?type=${currentItem}`
      );
    };
  };

  exportExcelIn5Year(service, currentItem, dataProviderForIpoCap, ipoHeader) {
    return function excelIn5Year() {
      if (currentItem === 'C') {
        service.exportExcelIpoExchangeIn5Year(
          dataProviderForIpoCap,
          ipoHeader,
          'Ipo Capraised 5 Year'
        )
      } else {
        service.exportExcelIpoExchangeIn5Year(
          dataProviderForIpoCap,
          ipoHeader,
          'Ipo Market Cap 5 Year'
        )
      }
    };
  };

  exportPptIn5Year(service, dataProviderForIpoCap, ipoHeader, textMark) {
    return function pptIn5Year() {
      service.pptIpoExchangeFiveYears(
        dataProviderForIpoCap,
        ipoHeader,
        textMark
      )
    };
  };

  exportFunctionsTopIpo() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailTopIpo(
        this.cpmService,
        this.aseanExchanges.ipoValue
      )
    );
    arrayOfFunctions.set(
      'print',
      this.exportPrintTopIpo(
        this.aseanExchanges.ipoValue
      )
    );
    arrayOfFunctions.set(
      'pdf',
      this.exportPdfTopIpo(
        this.aseanExchanges.ipoValue
      )
    );

    arrayOfFunctions.set(
      'excel',
      this.exportExcelTopIpo(
        this.excelService,
        this.date,
        this.aseanExchanges.ipoValue,
        this.aseanExchanges.ipoCountry,
        this.aseanExchanges.ipoFundRaised2,
        this.aseanExchanges.ipoNewvalue2,
        this.aseanExchanges.dataProvider,
        this.aseanExchanges.listTotal,
        this.aseanExchanges.ipoCountry2
      )
    );

    return arrayOfFunctions;
  }

  exportEmailTopIpo(service, ipoValue) {
    return function mailTopIpo() {
      service.saveExchangeTopIpoPdfFile(ipoValue).then(filename => {
        const subject = 'Asean-Exchange-Ipo';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  }

  exportPrintTopIpo = function (ipoValue) {
    return function TopIpoPrint() {
      const popupWin = window.open(
        `/#/initalPublicofferingTop10/${ipoValue}`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };

  exportPdfTopIpo = function (ipoValue) {
    const service = this.cpmService;
    return function TopIpoPdf() {
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/initalPublicofferingTop10?ipoValue=${ipoValue}`
      );
    };
  };

  exportExcelTopIpo(
    service, ipoAsofdate, ipoValue, ipoCountry, ipoFundRaised2,
    ipoNewvalue2, dataProvider, listTotal, ipoCountry2
  ) {
    return function excelTopIpo() {
      const ws_data = []
      const list4 = []
      list4.push(...[ipoAsofdate])
      ipoCountry.map(ipoObj => {
        list4.push(...[ipoObj])
      })
      ws_data.push([...list4])

      const list2 = []

      if (ipoValue === 'c') {
        list2.push(...['IPO capital raised (M. USD)'])
        ipoFundRaised2.map(ipoFundObj => {
          list2.push(...[ipoFundObj])
        })
        ws_data.push([...list2])
      } else {
        list2.push(...['IPO market cap (M. USD)'])
        ipoFundRaised2.map(ipoFundObj => {
          list2.push(...[ipoFundObj])
        })
        ws_data.push([...list2])
      }


      const list3 = []
      list3.push(...['Number of IPO'])
      ipoNewvalue2.map(ipoNewObj => {
        list3.push(...[ipoNewObj])
      })
      ws_data.push([...list3])

      ws_data.push('')

      const list5 = []

      if (ipoValue === 'c') {
        list5.push(...['Top 10 IPO capital raised (M. USD)'])
      } else {
        list5.push(...['Top 10 IPO market cap (M. USD)'])
      }

      ipoCountry2.map(ipoCountryObj => {
        list5.push(...[ipoCountryObj])
      })
      ws_data.push([...list5])


      dataProvider.map(dataObj => {
        const list = []
        list.push(dataObj.companyName)
        ipoCountry.map(ipoCounObj => {
          ipoCounObj === dataObj.country
            ? list.push(dataObj.fundRaised)
            : list.push(null)
        })
        ws_data.push([...list])
      })
      const listFooter2 = ['Grand Total (mn USD)']
      listTotal.map(obj => {
        listFooter2.push(...[obj.fundRaised])
      })
      ws_data.push(...[listFooter2])
      service.exportExcelData(ws_data, 'Asean-Exchange-Top-Ipo')
    };
  };


  numberToNoDecimal(num) {
    return Number(parseFloat(num).toFixed(0)).toLocaleString('en')
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/initial-public-offering/initial-public-offering.component.ts